import { AxiosResponse } from "axios"
import axiosInstance from "./axiosInstace"

export async function cancelTransactionId(transactionId: string): Promise<any> {
	const response: AxiosResponse = await axiosInstance.delete(
		`/salesorders/payment/cancel-pix/${transactionId}`,
	)

	return response.data
}